<template>
  <component-wrapper class="product-category-overview-fi">
    <grid-container-fi>
      <div class="product-category-overview-fi__header fi-col-span-full">
        <!-- eslint-disable vue/no-v-html -->
        <span
          v-if="isEditMode"
          class="product-category-overview-fi__headline-small"
          v-html="fields.headlineSmall.editable"
        />
        <span
          v-else-if="fields.headlineSmall"
          class="product-category-overview-fi__headline-small"
          v-html="fields.headlineSmall.value"
        />
        <h1
          v-if="isEditMode"
          class="product-category-overview-fi__headline fi-text-size-df-60"
          v-html="fields.headline.editable"
        />
        <h1
          v-else-if="fields.headline"
          class="product-category-overview-fi__headline fi-text-size-df-60"
          v-html="fields.headline.value"
        />
        <!-- eslint-enable vue/no-v-html -->
      </div>
    </grid-container-fi>

    <section-divider-small-fi />

    <div class="product-category-overview-fi__container">
      <grid-container-fi>
        <div
          class="product-category-overview-fi__grid fi-col-start-1 fi-col-end-13 lg:fi-col-start-2 lg:fi-col-end-12"
        >
          <a
            v-for="item in getAllCategories"
            :id="item.CategoryId"
            :key="item.CateogryId"
            class="product-category-overview-fi__item"
            :href="productUrl(item.Slug)"
          >
            <div class="product-category-overview-fi__item-image">
              <cloud-image-fi
                :src="item.thumbnailUrl ? item.thumbnailUrl.Url : placeholder"
                :width="isMD ? '110' : '96'"
                :height="isMD ? '110' : '96'"
                params="func=fit"
                do-not-replace-url
                trim
                class="product-category-overview-fi__item-img"
                :alt="item.CategoryName"
              />
            </div>
            <span class="product-category-overview-fi__item-name">{{ item.CategoryName }}</span>
          </a>
        </div>
      </grid-container-fi>
    </div>
  </component-wrapper>
</template>

<script>
import { CloudImageFi } from 'atoms';
import ComponentWrapper from 'components/component-wrapper/ComponentWrapper';
import GridContainerFi from 'components/grid-fi/GridContainerFi';
import GETALLCATEGORIES from 'gql/getAllCategories.gql';
import breakpointMixin from 'mixins/breakpointMixin';
import SectionDividerSmallFi from 'pages/section-divider-fi/SectionDividerSmallFi';

export default {
  name: 'ProductCategoryOverviewFi',
  components: {
    ComponentWrapper,
    GridContainerFi,
    CloudImageFi,
    SectionDividerSmallFi,
  },
  mixins: [breakpointMixin],
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      placeholder: 'https://via.placeholder.com/110x110/CCCCCC/000000?text=Placeholder',
    };
  },
  apollo: {
    getAllCategories: {
      query: GETALLCATEGORIES,
      variables() {
        return {
          baseSiteId: this.$fischer.baseSiteId(),
          language: this.$fischer.catalogLocale(),
        };
      },
    },
  },
  methods: {
    productUrl(itemSlug) {
      return `${this.$fischer.pages.products().url}${itemSlug}`;
    },
  },
};
</script>

<style scoped lang="scss">
@import './product-category-overview-fi';
</style>
